import GalleryItemChangedEvent from 'ui/events/GalleryItemChangedEvent';

/**
 * @callback $w.GalleryItemClickedEventHandler
 * @summary Handles events fired when an image in a gallery is clicked.
 * @param {$w.GalleryItemClickedEvent} event The event that has occurred.
 * @param {$w.$w} $w A selector function. The $w function enables event handlers
 *  to work with elements in [repeaters]($w.Repeater.html#repeating-callback-selector)
 *  and in the [global scope]($w.Repeater.html#regular-callback-selector).
 */

/**
 * @class GalleryItemClickedEvent
 * @summary Event that is fired when an image in a gallery is clicked.
 * @memberof $w
 * @mixes $w.GalleryItemChangedEvent
 * @mixes $w.Event
 */
export default class GalleryItemClickedEvent extends GalleryItemChangedEvent {}



// WEBPACK FOOTER //
// ./js/modules/ui/events/GalleryItemClickedEvent.es6